import { render } from "./CriteriaCard012.vue?vue&type=template&id=1b255902&scoped=true"
import script from "./CriteriaCard012.vue?vue&type=script&lang=js"
export * from "./CriteriaCard012.vue?vue&type=script&lang=js"

import "./CriteriaCard012.vue?vue&type=style&index=0&id=1b255902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b255902"]])

export default __exports__